import { business } from "./business.js";

export const baseFaqs = [
  {
    q: "À quelle fréquence Arklis intervient-il ?",
    a: "Arklis propose exclusivement des interventions hebdomadaires, avec un passage chaque semaine selon l'organisation convenue avec le foyer."
  },
  {
    q: "Arklis propose-t-il des passages à la demande ?",
    a: "Non. Arklis se consacre exclusivement au ménage hebdomadaire afin de proposer un service régulier, suivi et adapté aux habitudes de chaque foyer."
  },
  {
    q: "Comment obtenir un tarif ?",
    a: "Chaque logement et chaque besoin étant différent, Arklis ne publie pas de tarif standard. Vous pouvez remplir le formulaire de contact ou appeler le 06 65 76 31 58 afin d'échanger sur votre besoin."
  },
  {
    q: "Les prestations peuvent-elles ouvrir droit à un crédit d'impôt ?",
    a: "Les prestations de ménage à domicile Arklis peuvent ouvrir droit, sous réserve des conditions légales et de l'éligibilité du client, à un crédit d'impôt égal à 50 % des dépenses supportées, dans les limites et plafonds en vigueur."
  },
  {
    q: "Puis-je payer en CESU ?",
    a: "Oui, Arklis accepte le paiement en CESU selon les modalités applicables aux prestations de services à la personne."
  },
  {
    q: "Dans quelles villes Arklis intervient-il ?",
    a: `Arklis intervient chaque semaine dans le secteur de ${business.areaName}, notamment à ${business.cities.slice(0, 4).join(", ")} et dans les villes proches listées sur le site.`
  }
];

export const homeFaqs = baseFaqs;

export function localFaqs(city) {
  return [
    {
      q: `Arklis intervient-il chaque semaine à ${city} ?`,
      a: `Oui, Arklis propose le ménage hebdomadaire à domicile à ${city} et dans le secteur de Val d'Europe.`
    },
    {
      q: `Comment être recontacté pour un ménage à ${city} ?`,
      a: "Vous pouvez remplir le formulaire de contact du site ou appeler directement Arklis au 06 65 76 31 58."
    },
    {
      q: `Quelle prestation est proposée à ${city} ?`,
      a: "Arklis propose exclusivement le ménage hebdomadaire à domicile pour les particuliers, avec un passage chaque semaine."
    }
  ];
}
